import React from 'react';
import { CodeEditorField } from '@dopomogai/ui';

interface HeadersPanelProps {
  headers: object | null;
}

export const HeadersPanel: React.FC<HeadersPanelProps> = ({ headers }) => {
  return (
    <div className="h-full overflow-y-auto p-4">
      {headers ? (
        <CodeEditorField
          value={JSON.stringify(headers, null, 2)}
          language="json"
          readOnly
          theme="light"
          onChange={() => {}}
          showCopyButton
        />
      ) : (
        <div className="text-sm text-slate-500">
          No new headers received from the last stream. Look for `x-new-wat` on token refresh.
        </div>
      )}
    </div>
  );
};